import script from "./OkrTypeFieldOption.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrTypeFieldOption.vue?vue&type=script&setup=true&lang=js"

import "./OkrTypeFieldOption.vue?vue&type=style&index=0&id=7dfb4434&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dfb4434"]])

export default __exports__